import React from 'react';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import { useForm, Controller } from 'react-hook-form';
import { useIntl } from 'umi';
import SearchIcon from '@material-ui/icons/Search';
import ReplayIcon from '@material-ui/icons/Replay';
import { useTheme } from '@material-ui/core';
import { Box } from '@material-ui/core';
import Button from '@material-ui/core/Button';

import SearchGroupStyled from './SearchGroupStyled';

const SearchGroup = React.forwardRef((props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const { query } = props;
  const { handleSearch, restClick, searchRef } = props;
  const { id, title } = query;
  const theme = useTheme();
  const { handleSubmit, control, reset, setValue, getValues } = useForm({
    defaultValues: {
      id,
      title,
    },
  });

  //点击搜素
  const handleSubmitSuccess = (submitData) => {
    const propsSubmitData = {
      ...submitData,
    };

    handleSearch && handleSearch(propsSubmitData);
  };
  //点击重置
  const handleRestClick = () => {
    const resetSearch = {
      id: '',
      title: '',
    };
    reset(resetSearch);
    restClick && restClick(resetSearch);
  };

  return (
    <SearchGroupStyled theme={theme}>
      <form onSubmit={handleSubmit(handleSubmitSuccess)}>
        <Box className="card-content">
          <Box className="left">
            <Box className="line">
              <Controller
                render={(rp) => (
                  <TextField
                    sx={{ width: '200px' }}
                    name="id"
                    variant="standard"
                    label="货架ID"
                    value={rp.value ?? ''}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^\d]/g, '');
                      setValue('id', value);
                      return rp.value;
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('id', '');
                            }}
                            edge="end"
                          >
                            {id ? <ClearIcon className="clear-icon" /> : ''}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="id"
                variant="standard"
                control={control}
                id="basic"
                className="input"
                defaultValue={''}
              />

              <Controller
                render={(rp) => (
                  <TextField
                    sx={{ width: '200px' }}
                    name="title"
                    control={control}
                    id="basic"
                    variant="standard"
                    className="input"
                    label="货架标题"
                    defaultValue=""
                    value={rp.value ?? ''}
                    onChange={(e) => {
                      setValue('title', e.target.value);
                      return rp.value;
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('title', '');
                            }}
                            edge="end"
                          >
                            {getValues('title') ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="title"
                control={control}
                id="basic"
                variant="standard"
                className="input"
                defaultValue=""
              />
            </Box>
          </Box>
          <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              className="reset"
              onClick={handleRestClick}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'comm.action.btn.06' })}
            </Button>

            <Button
              data-log={JSON.stringify({
                oid: 'btn_point_mall_shelf_management_list_search',
                events: ['_ev'],
                params: {
                  initUrl: window.location.origin + window.location.pathname,
                },
              })}
              ref={searchRef}
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'comm.action.btn.01' })}
            </Button>
          </Box>
        </Box>
      </form>
    </SearchGroupStyled>
  );
});

export default SearchGroup;
